import {Component, OnInit} from '@angular/core';
import {Error} from 'src/app/interfaces/error.interface';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from 'src/app/shared/constants.shared';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  error: Error;

  constructor(
    private translate: TranslateService,
    private session: SessionService) {
    this.error = this.session.error ? this.session.error : Constants.ErrorTemplate.ERROR_GENERIC;
  }

  ngOnInit(): void {
    if(this.error.redirectUrl) {
      this.serviceProviderRedirect(this.error.redirectUrl)
    }
  }

  serviceProviderRedirect(url: string){
    setTimeout(() => {
      window.location.href = url;
    }, 5000);
  }
}
